import type { Order } from '@/types/api/order'
import type {
  AllocationSummary,
  AllocationUpdateEvent,
} from './allocation-update'
import type { OrderUpdateEvent } from './order-update'
import type { SystemUpdateEvent } from './system-update'

// See docs: https://docs.withmoment.com/reference/real-time-orders-api
export enum TradingEventMessageType {
  OrderUpdate = 'order_update',
  AllocationUpdate = 'allocation_update',
  SystemUpdate = 'system_update',
}

interface TradingEventMessageBase {
  msg_type: TradingEventMessageType
  msg_number: string
  event_id: string
}

export interface OrderUpdateEventMessage extends TradingEventMessageBase {
  msg_type: TradingEventMessageType.OrderUpdate
  order: Order
  event: OrderUpdateEvent
}

export interface AllocationUpdateEventMessage extends TradingEventMessageBase {
  msg_type: TradingEventMessageType.AllocationUpdate
  summary: AllocationSummary
  event: AllocationUpdateEvent
}

export interface SystemUpdateEventMessage extends TradingEventMessageBase {
  msg_type: TradingEventMessageType.SystemUpdate
  event: SystemUpdateEvent
}

export type TradingEventMessage =
  | OrderUpdateEventMessage
  | AllocationUpdateEventMessage
  | SystemUpdateEventMessage

export interface TradingEventsArgs {
  startHwm?: string
  endHwm?: string
  cacheKey: string
}
